import { formatMoney } from '@/lib/format';

/*
 * MoneyCell (spec §7.4, §7.5). Displays minor units via Intl. The FE formats
 * money, never computes it. Domain-free: takes primitives via props.
 */
export function MoneyCell({
  amountMinor,
  currency,
}: {
  amountMinor: number;
  currency: string;
}) {
  // Mono + tabular-nums matches the proto's `font-mono` amount idiom and keeps
  // digits aligned in dense tables (POC parity §3.6).
  return (
    <span className="font-mono tabular-nums" data-slot="money">
      {formatMoney(amountMinor, currency)}
    </span>
  );
}
